// ===================== 【配置区：只改这里】 =====================
export const MAINTAIN_CONFIG = {
    // 警告条：到这个时间自动隐藏
    warningEndTime: "2026-05-09 23:00:00",

    // ==============================================
    // 维护状态时间（数组写法，自动识别）
    // ==============================================
    // 写法 1：单个时间点 → [ '2026-05-09 23:00:00' ]
    // 写法 2：时间范围   → [ '开始时间', '结束时间' ]
    // 写法 3：关闭不显示 → 不写 或 []
    maintainTime: ["2026-05-09 23:00:00"]
};

// ===================== 【逻辑区：不用改】 =====================

// 1. 警告条是否显示
export function showWarningBar() {
    const now = new Date();
    const end = new Date(MAINTAIN_CONFIG.warningEndTime);
    return now < end;
}

// 2. 维护状态是否显示（数组自动判断）
export function showMaintenanceStatus() {
    const now = new Date().getTime();
    const { maintainTime } = MAINTAIN_CONFIG;

    // 没配置 或 空数组 → 不显示
    if (!maintainTime || maintainTime.length === 0) {
        return false;
    }

    // 情况1：数组只有1个值 → 小于等于该时间就显示
    if (maintainTime.length === 1) {
        const target = new Date(maintainTime[0]).getTime();
        return now <= target;
    }

    // 情况2：数组有2个值 → 在开始~结束时间范围内显示
    if (maintainTime.length === 2) {
        const start = new Date(maintainTime[0]).getTime();
        const end = new Date(maintainTime[1]).getTime();
        return now >= start && now <= end;
    }

    return false;
}
